import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Ошибка',
  code: 'Код ошибки:',
  button: {
    support: 'Написать в поддержку',
    confirm: 'Понятно',
  },
} satisfies TMessages
